import { Link } from 'react-router'
import { Icon, Stack, Text } from '@/design-system'
import { formatMoney } from '@/lib/money'
import type { Transaction } from '@/data/types'
import styles from './TransactionRow.module.css'

const dateFormatter = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' })

export function TransactionRow({ transaction }: { readonly transaction: Transaction }) {
  const { counterparty, category, icon, amount, direction, occurredAt, cashback } = transaction
  return (
    <Link className={styles.row} to={`/transactions/${transaction.id}`}>
      <span className={styles.glyph}>
        <Icon name={icon} size={18} />
      </span>
      <Stack grow gap={0}>
        <Text variant="caption" weight="semibold" truncate>
          {counterparty}
        </Text>
        <Text variant="caption" tone="secondary" truncate>
          {category} · {dateFormatter.format(new Date(occurredAt))}
        </Text>
      </Stack>
      <div className={styles.amounts}>
        <Text variant="caption" weight="semibold" tone={direction === 'in' ? 'positive' : 'primary'} numeric>
          {formatMoney(amount, { signed: direction === 'in' })}
        </Text>
        {cashback && (
          <Text variant="eyebrow" weight="bold" tone="positive" numeric>
            {formatMoney(cashback, { signed: true })} back
          </Text>
        )}
      </div>
    </Link>
  )
}
